import SlideModal from "../../../components/slide-modal";
import { ChangeEvent, FC, useEffect, useState } from "react";
import { SearchBox } from "../../../components/search-box";
import { TInput } from "@ht/components/src/forms/form-elements/types";
import Plus from "@ht/shared/fonts/deos-pis/plus";
import { ScrollBar } from "@ht/components";
import useFetchUserList, { IUsers } from "../hooks/useFetchUserList";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { startAgentChat } from "../../../app/chatAgent/chatAgentSlice"
import getInitials from "../../../utils/getInitials";
import generateUuid from "../../../utils/generateUuid";

export interface ChildProps {
    visible: boolean;
    onClose: () => void;
}

export interface IRoom {
    roomId: string;
}

const UserListSlideModal: FC<ChildProps> = ({ onClose, visible }) => {
    const dispatch = useAppDispatch();
    const { user } = useAppSelector((state) => state.auth);
    const [filteredList, setFilteredList] = useState<IUsers[]>([]);
    const [searchKeyword, setSearchKeyword] = useState("");
    const alphabet = Array.from({ length: 26 }, (_, index) => String.fromCharCode('A'.charCodeAt(0) + index));
    const { results } = useFetchUserList({
        tenantid: user ? user?.tenantId : "",
        agentUsername: user?.username,
        roleName: user?.cmRoleName
    });

    const searchHandler = (e: ChangeEvent<TInput>) => {
        const value = e.target.value.toLowerCase();
        const filtered = results?.filter(
            a => a.fullname?.toLowerCase().includes(value) ||
                a.role_name?.toLowerCase().includes(value)
        );
        setFilteredList(filtered);
        setSearchKeyword(value);
    }

    const addChatHandler = (props: any) => {
        const receiverObj = {
            toUserName: props,
            tenantId: user?.tenantId
        }
        setSearchKeyword("");
        dispatch(startAgentChat(receiverObj));
        onClose();
    }
    useEffect(() => {
        setFilteredList(results);
    }, [results])

    useEffect(() => {
        setSearchKeyword("");
    }, [visible])

    return (
        <SlideModal
            title="User Contact List"
            onClose={onClose}
            visible={visible}
            direction="RIGHT_TO_LEFT"
            className="h-[89vh] xxsToXs:w-[97%] xsToSm:w-[97%] top-14 w-[500px]"
        >
            {visible &&
                <div className="flex flex-col w-full h-[724px] space-y-4">
                    <div className="w-full h-fit">
                        <SearchBox name="searchUser" onChange={searchHandler} value={searchKeyword} />
                    </div>

                    <div className="h-[65%] w-full space-y-4">
                        <ScrollBar>
                            <div className="space-y-4 pr-4">
                                {alphabet.map((i: string) => {
                                    if (filteredList.some(letter => letter.fullname.charAt(0).toLocaleUpperCase() == i)) {
                                        return (
                                            <div className="flex flex-col items-start space-y-1 w-full" key={generateUuid()}>
                                                <div className="font-bold text-gray-700 text-md w-full">
                                                    {i}
                                                    <div className="flex flex-col items-start w-full">
                                                        {filteredList.map((item) => {
                                                            return (
                                                                item.fullname?.toLowerCase()?.startsWith(i.toLowerCase()) && (
                                                                    <div className="flex flex-row items-center gap-3 w-full" key={generateUuid()}>
                                                                        <div className="bg-gray-300 rounded-full w-9 h-8 flex items-center justify-center text-base">
                                                                            <span>{getInitials(item.fullname)}</span>
                                                                        </div>
                                                                        <div className="flex flex-row items-center py-3 gap-6 border-b-[1px] border-gray-100 w-full">
                                                                            <div className="flex flex-col items-start gap-1.5">
                                                                                <div className="text-gray-700 font-semibold text-md">{item.fullname}</div>
                                                                                <div className="flex flex-row items-start gap-1 text-base font-normal text-gray-400">
                                                                                    {item.role_name}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <button className="text-gray-400" onClick={() => { addChatHandler(item.username) }}>
                                                                            <Plus />
                                                                        </button>
                                                                    </div>
                                                                )
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                })}

                            </div>
                        </ScrollBar>
                    </div>
                </div>
            }
        </SlideModal>
    );
};

export default UserListSlideModal;